import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { IIconLink, SdSocialMediaComponent } from '@seb/web-design-system/core';

import { CmsLinkDSComponentInterface, SocialNetworkModuleInterface } from '../../../models';
import { AbstractModuleComponent } from '../abstract-module.component';
import { LinkMapper } from '../../../mappers';

@Component({
  selector: 'wc-social-network-module',
  templateUrl: './social-network-module.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdSocialMediaComponent]
})
export class SocialNetworkModuleComponent extends AbstractModuleComponent<SocialNetworkModuleInterface> implements OnInit {
  links: IIconLink[];

  constructor(
    private linkMapper: LinkMapper,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  override mandatoryComponentFunction = (cmp: CmsLinkDSComponentInterface): boolean => {
    return !!cmp.picto && (!!cmp.url || !!cmp.urlLocalized);
  };

  ngOnInit(): void {
    this.subscriptions.add(
      this.module$.subscribe((module: SocialNetworkModuleInterface) => {
        this.links = module.componentsObjects.map((link) => this.linkMapper.toIconLink(link));

        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }
}
